module.exports = __webpack_public_path__ + "img/dark.7b85de77.png";